export default __webpack_public_path__ + "static/media/bmw-650.5bd01b3e.png";